import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { $, merge } from "glamor";
import classNames from "classnames";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { VIEW_PRODUCT_LIST } from "constants/view-defs";
import theme from "styles/theme";
import { blurFix } from "styles/mixins";

const styles = merge(
    {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    $(" .listView, .listView.image", {
        borderRadius: "50%",
        height: "32px",
        width: "32px",
        marginLeft: "4px",
        objectFit: "contain",
    }),
    $(" .image", {
        // do not touch these styles without very-very important reason
        alignSelf: "center",
        display: "block",
        maxHeight: "100%",
        maxWidth: "100%",
        transition: "opacity 0.2s ease-out",
        ...blurFix,
    }),
    $(" .image1st", {
        position: "absolute",
        transform: "translate(-50%, -50%)",
    }),
    $(" .image2nd", {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    }),
    $(" .indicator", {
        position: "absolute",
        top: "37px",
        left: "14px",
        height: "50px",
        width: "50px",
        backgroundColor: "rgba(255, 255, 255, .8)",
        borderRadius: "4px",
        border: `1px solid ${theme.palette.borderColor}`,
    })
);

/** @augments {PureComponent<any, any>} */
class Image extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        index: PropTypes.number,
        swapOnHover: PropTypes.bool,
        scope: PropTypes.object.isRequired,
        view: PropTypes.object,
        size: PropTypes.string,
        classes: PropTypes.object,
    };

    static defaultProps = {
        index: 0,
        swapOnHover: false,
    };

    static muiStyles = {
        checkbox: {
            width: "50px",
            height: "42px",
            color: theme.palette.primary1Color,
        },
    };

    constructor(props) {
        super(props);
        this.defaultImage =
            props.scope.brand && `//cdn1.nuorder.com/brands/${props.scope.brand.settings.missing_logo_image}.jpg`;
    }

    UNSAFE_componentWillMount() {
        this.setInitialState();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.scope.brand && !this.props.scope.brand) {
            this.defaultImage = `//cdn1.nuorder.com/brands/${nextProps.scope.brand.settings.missing_logo_image}.jpg`;
        }

        // reset
        if (nextProps.item !== this.props.item || nextProps.index !== this.props.index) {
            this.setInitialState(nextProps);
        }
    }

    setInitialState(props = this.props) {
        const { index, item, scope, view, size } = props;
        let imageSize = size || "G";
        imageSize = view && view.view_name === VIEW_PRODUCT_LIST ? "T" : imageSize;
        const image = item ? item.getImageUrl(scope, imageSize, index) : this.defaultImage;
        const image2 = item?.getImageUrl(scope, imageSize, index + 1);

        this.setState({
            image,
            image2,
            opacity: 1,
            imageLoadingScope: image === this.defaultImage ? 1 : 0,
        });
    }

    handleError = () => {
        this.setState({
            image:
                this.state.imageLoadingScope >= 1
                    ? "//cdn1.nuorder.com/brands/1womenswholesale_missing.jpg"
                    : this.defaultImage,
            imageLoadingScope: this.state.imageLoadingScope + 1,
        });
    };

    render() {
        const {
            item,
            scope,
            view,
            swapOnHover,
            flags: { swapProductImageOnHover: canSwapImage } = {},
            classes = {},
        } = this.props;
        const { imageLoadingScope, image, image2, opacity } = this.state;

        const swap = canSwapImage && swapOnHover && image2;

        if (!item || !scope.brand || !image) {
            return null;
        }

        return (
            <div {...styles} className={classNames(classes.wrapper)}>
                <picture
                    onMouseEnter={swap ? () => this.setState({ opacity: 0 }) : undefined}
                    onMouseLeave={swap ? () => this.setState({ opacity: 1 }) : undefined}
                    className={classNames(classes.picture)}
                >
                    <img
                        src={image}
                        role="presentation"
                        style={{ opacity }}
                        className={classNames({
                            image: true,
                            listView: view?.view_name === VIEW_PRODUCT_LIST,
                            image1st: true,
                            [classes.image]: !!classes.image,
                        })}
                        onError={imageLoadingScope >= 2 ? undefined : this.handleError}
                    />
                    {swap && (
                        <img
                            src={image2}
                            role="presentation"
                            style={{ opacity: 1 - opacity }}
                            className={classNames(["image", "image2nd", classes.image])}
                        />
                    )}
                </picture>
            </div>
        );
    }
}

export { Image };
export default withLDConsumer()(Image);
